"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var TemplatesMonitoring_1 = require("../monitoring/TemplatesMonitoring");
var CredentialsHandler_1 = require("./CredentialsHandler");
var SelectProjectDialogWidget_1 = require("./select_project/SelectProjectDialogWidget");
var PublishingWaitingDialog_1 = require("./waiting_dialogs/PublishingWaitingDialog");
var WorkbookFromTemplateFactory_1 = require("./WorkbookFromTemplateFactory");
var CreateTemplateFlow = /** @class */ (function (_super) {
    __extends(CreateTemplateFlow, _super);
    function CreateTemplateFlow(props) {
        var _this = _super.call(this, props) || this;
        _this.projectId = '';
        _this.workbookName = '';
        _this.showWaitingDialog = function () {
            _this.setState({ showingSelectProject: false, showingWaitingDialog: true });
        };
        _this.hideWaitingDialog = function () {
            _this.setState({ showingSelectProject: false, showingWaitingDialog: false });
        };
        _this.hideProjectSelectDialog = function () {
            _this.setState({ showingSelectProject: false, showingWaitingDialog: false });
        };
        _this.onCloseProjectSelectDialog = function () {
            _this.hideProjectSelectDialog();
            window.setTimeout(function () { return _this.props.onCancel(); }, 0);
        };
        _this.projectSelected = function (projectId, workbookName) { return __awaiter(_this, void 0, void 0, function () {
            var bypassConnectingDialog, sessionRelevantInfo, oauthCredentialsParams;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.hideProjectSelectDialog();
                        this.projectId = projectId;
                        this.workbookName = workbookName;
                        TemplatesMonitoring_1.monitorProjectSelected(this.props.templateId, projectId, workbookName);
                        bypassConnectingDialog = false;
                        return [4 /*yield*/, CredentialsHandler_1.CredentialsHandler.getSessionRelevantInfo()];
                    case 1:
                        sessionRelevantInfo = _a.sent();
                        oauthCredentialsParams = CredentialsHandler_1.CredentialsHandler.getOauthCredentialsParams(this.props.connectionType, this.props.helpVersion, this.onCredentialAdded, sessionRelevantInfo, this.props.JumpstartTelemetry, bypassConnectingDialog, // This means it will show the bypass connection dialog.
                        this.handleOnProceedNoSignIn);
                        return [4 /*yield*/, CredentialsHandler_1.CredentialsHandler.addCredentialsAsync(oauthCredentialsParams)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.onCredentialAdded = function (credentialId, 
        // tslint:disable-next-line no-any
        credentialProperties // not used but the callback requires it
        ) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.showWaitingDialog();
                        return [4 /*yield*/, WorkbookFromTemplateFactory_1.WorkbookFromTemplateFactory.createWorkbook(this.props.templateId, this.workbookName, this.props.connectionType, credentialId, this.projectId, this.props.onTemplateCreated)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.handleOnProceedNoSignIn = function () { return __awaiter(_this, void 0, void 0, function () {
            var noCreds;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        noCreds = '';
                        return [4 /*yield*/, WorkbookFromTemplateFactory_1.WorkbookFromTemplateFactory.createWorkbookWithoutProjectSelection(this.workbookName, noCreds, this.props.templateId, this.props.connectionType, this.props.onTemplateCreated)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.workbookName = props.initialWorkbookName;
        _this.state = {
            showingSelectProject: props.initialShowSelectProject,
            showingWaitingDialog: false,
        };
        return _this;
    }
    CreateTemplateFlow.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        return (nextState.showingSelectProject !== this.state.showingSelectProject ||
            nextState.showingWaitingDialog !== this.state.showingWaitingDialog);
    };
    CreateTemplateFlow.prototype.render = function () {
        if (this.state.showingSelectProject) {
            var dialogProps = {
                initialWorkbookName: this.props.initialWorkbookName,
                siteName: this.props.siteName,
                onCloseRequest: this.onCloseProjectSelectDialog,
                projectSelected: this.projectSelected,
                JumpstartTelemetry: this.props.JumpstartTelemetry,
            };
            return React.createElement(SelectProjectDialogWidget_1.SelectProjectDialogWidget, __assign({}, dialogProps));
        }
        else if (this.state.showingWaitingDialog) {
            return (React.createElement(PublishingWaitingDialog_1.PublishingWaitingDialog, { onCloseRequest: this.hideWaitingDialog, JumpstartTelemetry: this.props.JumpstartTelemetry }));
        }
        return null;
    };
    return CreateTemplateFlow;
}(React.Component));
exports.CreateTemplateFlow = CreateTemplateFlow;
//# sourceMappingURL=CreateTemplateFlow.js.map